import isEmpty from 'lodash/isEmpty';
import BaseElement, { BaseElementProps } from '../base/BaseElement';
import { Omit } from '@vindr/utils/helpers/common.helper';

export interface InputElementProps extends BaseElementProps {
  placeholder?: string;
  default_value: string;
}

class InputElement extends BaseElement {
  public default_value: string;
  public label: string;
  public is_show_label: boolean;
  public is_editable_value: boolean;
  public placeholder: string;

  constructor(props: InputElementProps) {
    super(props);
    const { default_value, label, is_show_label, value, is_editable_value, placeholder } =
      props || {};

    this.level = (props.parent?.level ?? -1) + 1;
    this.default_value = default_value;
    this.value = value || default_value || '';
    this.label = label;
    this.is_show_label = is_show_label;
    this.is_editable_value = is_editable_value;
    this.placeholder = placeholder;
  }

  public setValue(value: string) {
    this.value = value || '';
    return this;
  }

  public render(): string {
    const value = isEmpty(this.value) ? '' : this.value;
    if (this.is_hidden) return '';
    return `<span ${this.highlight ? 'style="background-color: yellow;"' : ''}>${
      this.is_show_label ? this.label + value : value
    }</span>`;
  }

  toJSON() {
    return Omit(this, ['parent', 'highlight']);
  }
}

export default InputElement;
